"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteApprovedFeedstockUseCase = exports.editApprovedFeedstockUseCase = exports.createApprovedFeedstockUseCase = exports.getApprovedFeedstocksUseCase = void 0;
const approvedFeedstocks_1 = require("@/store/ducks/approvedFeedstocks");
const aprovedFeedstocks_1 = require("@/services/aprovedFeedstocks");
function getApprovedFeedstocksUseCase() {
    return (dispatch) => {
        dispatch((0, approvedFeedstocks_1.getApprovedFeedstocksReducer)());
        return (0, aprovedFeedstocks_1.getApprovedFeedstocksService)()
            .then((approvedFeedstocks) => {
            dispatch((0, approvedFeedstocks_1.getApprovedFeedstocksSuccessReducer)(approvedFeedstocks));
        })
            .catch(() => {
            dispatch((0, approvedFeedstocks_1.getApprovedFeedstocksErrorReducer)());
        });
    };
}
exports.getApprovedFeedstocksUseCase = getApprovedFeedstocksUseCase;
function createApprovedFeedstockUseCase(payload) {
    return (dispatch) => {
        dispatch((0, approvedFeedstocks_1.createApprovedFeedstockReducer)());
        return (0, aprovedFeedstocks_1.createApprovedFeedstockService)(payload)
            .then(() => {
            dispatch((0, approvedFeedstocks_1.createApprovedFeedstockSuccessReducer)());
            getApprovedFeedstocksUseCase()(dispatch);
        })
            .catch(() => {
            dispatch((0, approvedFeedstocks_1.createApprovedFeedstockErrorReducer)());
        });
    };
}
exports.createApprovedFeedstockUseCase = createApprovedFeedstockUseCase;
function editApprovedFeedstockUseCase(feedstockId, payload) {
    return (dispatch) => {
        dispatch((0, approvedFeedstocks_1.editApprovedFeedstockReducer)());
        return (0, aprovedFeedstocks_1.editApprovedFeedstockService)(feedstockId, payload)
            .then(() => {
            dispatch((0, approvedFeedstocks_1.editApprovedFeedstockSuccessReducer)());
            getApprovedFeedstocksUseCase()(dispatch);
        })
            .catch(() => {
            dispatch((0, approvedFeedstocks_1.editApprovedFeedstockErrorReducer)());
        });
    };
}
exports.editApprovedFeedstockUseCase = editApprovedFeedstockUseCase;
function deleteApprovedFeedstockUseCase(feedstockId) {
    return async (dispatch) => {
        dispatch((0, approvedFeedstocks_1.deleteApprovedFeedstockReducer)());
        return (0, aprovedFeedstocks_1.deleteApprovedFeedstocksService)(feedstockId)
            .then(() => {
            dispatch((0, approvedFeedstocks_1.deleteApprovedFeedstockSuccessReducer)());
            getApprovedFeedstocksUseCase()(dispatch);
        })
            .catch(() => {
            dispatch((0, approvedFeedstocks_1.deleteApprovedFeedstockErrorReducer)());
        });
    };
}
exports.deleteApprovedFeedstockUseCase = deleteApprovedFeedstockUseCase;
